import { motion } from "framer-motion";

export const Reveal = ({ children, className, delay = 0, y = 28, ...rest }) => (
  <motion.div {...rest} className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, margin: "-60px" }} transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}>
    {children}
  </motion.div>
);
